import React, { useState } from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { BiX } from 'react-icons/bi';
import { FaCalendarTimes } from 'react-icons/fa';

const AvailableSchedulesModal = ({ show, handleClose, schedules, route }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(5);
  const [isHovered, setIsHovered] = useState(false);
  console.log("route passed to AvailableSchedulesModal: ", route);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const totalPages = Math.ceil(schedules.length / pageSize);

  if (schedules.length === 0) {
    return (
      <Modal show={show} onHide={handleClose} backdrop="static" size="lg" className="available-schedules-modal">
      <Modal.Header>
        <div>
        <Modal.Title>Available Schedules</Modal.Title>
        {route && (
          <div style={{ fontSize: '0.85rem', color: '#777' }}>
            <div>for {route.origin} to {route.destination}</div>
            <div>Preferred Provider: {route.provider}</div>
            <div>Total Schedules: {schedules.length ? schedules.length.toLocaleString() : '0'}</div>
          </div>
        )}
        </div>
        <Button
          variant="link"
          onClick={handleClose}
          className="ms-auto"
          style={{ position: 'absolute', top: '10px', right: '10px', textDecoration: 'none' }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <BiX size={24} color={isHovered ? 'white' : 'inherit'} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center p-3">
        <FaCalendarTimes size={24} style={{ marginRight: '0.5rem' }} />
        No schedules match the specified routing guide
        </div>
      </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      size="lg"
      className="available-schedules-modal"
    >
      <Modal.Header>
        <div>
          <Modal.Title>Available Schedules</Modal.Title>
          {route && (
            <div style={{ fontSize: '0.85rem', color: '#777' }}>
              <div>for {route.origin} to {route.destination}</div>
              <div>Preferred Provider: {route.provider}</div>
              <div>Total Schedules: {schedules.length ? schedules.length.toLocaleString() : '0'}</div>
            </div>
          )}
        </div>
        <Button
          variant="link"
          onClick={handleClose}
          className="ms-auto"
          style={{ position: 'absolute', top: '10px', right: '10px', textDecoration: 'none' }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <BiX size={24} color={isHovered ? 'white' : 'inherit'} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              {schedules.length > 0 &&
                Object.keys(schedules[0]).map((col) => <th key={col}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {schedules.slice(startIndex, endIndex).map((row, rowIndex) => (
              <tr key={rowIndex}>
                {Object.keys(row).map((col) => {
                  let val = row[col];
                  if ((val && col.endsWith('CD')) || (col === 'POL ETD') || (col === 'POD ETA')) {
                    const dateObj = new Date(val);
                    if (!isNaN(dateObj.getTime())) {
                      val = dateObj.toLocaleString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                      }).replace(',', '');
                    }
                  }
                  return <td key={col}>{val}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between">
          <Button onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))} disabled={currentPage === 1}>
            Previous
          </Button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <Button
            onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AvailableSchedulesModal;